"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var typestyle_1 = require("typestyle");
var styles_1 = require("../styles");
var kAvatarWidths = {
    small: '2rem',
    track: '3rem',
    medium: '4rem',
    large: '6rem',
    xl: '8rem',
};
var kAvatarFontSizes = {
    small: '1rem',
    track: '1.2rem',
    medium: '2rem',
    large: '3rem',
    xl: '4rem',
};
var kBorderWidths = {
    small: 1.5,
    track: 2,
    medium: 2,
    large: 2.5,
    xl: 3,
};
var baseAvatar = function (props) {
    var size = props.size;
    var width = kAvatarWidths[size];
    var height = kAvatarWidths[size];
    return {
        position: 'relative',
        boxSizing: 'border-box',
        width: width,
        height: height,
        cursor: props.hasClickHandler ? 'pointer' : 'default',
        $nest: {
            '& > img': __assign(__assign({}, generateColorProps(props)), { padding: props.hideBorder ? '1px' : 0, width: width,
                height: height, borderRadius: '50%' }),
        },
    };
};
var generateColorProps = function (_a) {
    var size = _a.size, colorStops = _a.colorStops, hideBorder = _a.hideBorder;
    var baseColor = colorStops[0];
    var borderColor = baseColor
        ? baseColor.isDark()
            ? baseColor.lighten(0.1)
            : baseColor.darken(0.1)
        : styles_1.getColor('textdark');
    var textColor = baseColor && baseColor.isDark() ? styles_1.getColor('textlight') : styles_1.getColor('textdark');
    var colorProps = {
        border: hideBorder ? 'none' : kBorderWidths[size] + "px solid " + borderColor.hex(),
        color: textColor.hex(),
    };
    if (colorStops.length > 0) {
        colorProps = __assign(__assign({}, colorProps), { backgroundColor: baseColor.hex() });
    }
    if (colorStops.length > 1) {
        colorProps = __assign(__assign({}, colorProps), { background: "linear-gradient(" + colorStops.map(function (stop) { return stop.hex(); }).join(', ') + ")" });
    }
    return colorProps;
};
var initials = function (props) {
    var size = props.size, hasClickHandler = props.hasClickHandler;
    return typestyle_1.style(__assign(__assign(__assign({}, baseAvatar(props)), generateColorProps(props)), { overflow: 'hidden', borderRadius: '50%', fontSize: kAvatarFontSizes[size], display: 'flex', alignItems: 'center', justifyContent: 'center', userSelect: 'none', cursor: hasClickHandler ? 'pointer' : 'default', pointerEvents: 'none' }));
};
var avatar = function (props) {
    return props.imageUrl
        ? typestyle_1.style(baseAvatar(props), typestyle_1.media({ maxWidth: 900 }, {
            width: kAvatarWidths.small,
            height: kAvatarWidths.small,
            $nest: {
                '& > img': {
                    width: kAvatarWidths.small,
                    height: kAvatarWidths.small,
                },
            },
        }))
        : initials(props);
};
var hoverIcon = function (_a) {
    var colorStops = _a.colorStops;
    var baseColor = colorStops[0];
    var isDarkBackground = baseColor && baseColor.isDark();
    return typestyle_1.style({
        color: isDarkBackground ? styles_1.getHex('textlight') : styles_1.getHex('textdark'),
        opacity: 0,
        position: 'absolute',
        width: '60%',
        height: '60%',
        padding: '20%',
        zIndex: 1,
        $nest: {
            '&:hover': {
                opacity: 0.85,
                $nest: {
                    '& ~ span': {
                        opacity: 0,
                    },
                },
            },
        },
    });
};
exports.styles = {
    avatar: avatar,
    hoverIcon: hoverIcon,
};
